<template>
  <div>
    <Produits />
  </div>
</template>

<script>
import Produits from "@/components/boutique/Produits";
export default {
  components: {
    Produits,
  },
};
</script>

<style scoped>
</style>